import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';


@Injectable()
export class LoginService {

  options: any;

  constructor(private http: HttpClient) { }

  /* Call login API */
  postLoginData(data){
    const params = data;
    return this.http.post(environment.restAPI + 'login',
    params, {}).pipe(map((res: any) => res));
  }

  /* Call forgot password API */
  postForgotPasswordData(data){
    const params = {userName : ''};
    params.userName = data;
    return this.http.post(environment.restAPI + 'sendEmail/',
    params, {}).pipe(map((res: any) => res));
  }

  displayUserName(data) {
    return data.name;
  }

  /* Call consent API */
  postConsentData(data){
    const headersItem = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'CTL ' + data.token
    });
    this.options = {headers: headersItem};

    delete data.token;
    const params = data;
    return this.http.post(environment.restAPI + 'consent', params, this.options).pipe(map((res: any) => res));
  }
}
